import { Provider } from '@angular/core';
import { provideState } from '@ngrx/store';

import * as fromUser from './user';

export function provideUserState(): Provider {
  return [provideState(fromUser.featureKey, fromUser.reducer)];
}
